import { XMLParser } from "fast-xml-parser";

const xmlParser = new XMLParser({
    attributeNamePrefix: '',
    ignoreAttributes: false,
    parseNodeValue: true,
    parseAttributeValue: true,
    trimValues: true,
    arrayMode: false
});

export default xmlParser;